<ng-content></ng-content>

<div class="icon-container">
  <span class="icon-indicator revert-indicator"
        *ngIf="!preventRevert && hasActiveVersionAndChanges()"
        (click)="revertSpecificChange()">
    <i class="icon tce-icon-circle-cross"></i>
  </span>

  <span [class.bullet-indicator]="!noticeType || noticeType === 'bullet'"
        [class.icon-indicator]="noticeType === 'icon'"
        class="draft"
        *ngIf="showDraftChanges()">
    <i *ngIf="noticeType === 'icon'" class="icon tce-icon-copy-to-clipboard"></i>
  </span>

  <span [class.bullet-indicator]="!noticeType || noticeType === 'bullet'"
        [class.icon-indicator]="noticeType === 'icon'"
        class="scheduled"
        *ngIf="showScheduledChanges()">
    <i *ngIf="noticeType === 'icon'" class="icon tce-icon-pending"></i>
  </span>
</div>
